module.exports = __webpack_public_path__ + "static/media/mobile-app-promotion-en.bc73cdba.png";